/**
 * 引入fetch、baseUrl
 * @param params
 * @returns {*}
 */
import {fetch, postB, postQ, get} from 'urlconf/index'
import global from '../config/global'
import md5 from 'js-md5'
import {gs, gsWithAcc, isnull, localClear, localGet, localSave, Toast} from '../utils/tools'
import {login, loginOut} from '../pages/live/chat'
import accountapi from './account-api'
import {resolvePush} from '../push/SSEPushReceiver'
import {log} from '../utils/devext'
import aes from '../utils/aes'
import TipsUtils, {ResultCode} from '../utils/TipsUtils'
import IMManager from '../im/IMManager'
import {postQB} from '../apiconfig'

// 登录接口
export function loginUserNo (params) {
  return fetch(`/root/login/checkMemberLogin`, params)
}

// 游客登陆
export function tryPlay (params, successCallback = null, failCallBack = null) {
  return postB('api/Account/TryPlay', params, successCallback, function (code, msg) {
    failCallBack && failCallBack(code, msg, vueObj)
  })
}

export function getUserInfo (accId, successCallback = null, failCallBack = null, vueObj, showLoading = true, hideLoading = true) {
  // eslint-disable-next-line no-undef
  return get('api/Account/GetUserInfo', ['session=' + localGet(global.key.session), 'userId=' + accId], function (data) {
    successCallback && successCallback(data, vueObj)
  }, function (code, msg) {
    failCallBack && failCallBack(code, msg, vueObj)
  }, '/webApp', vueObj, showLoading, hideLoading)
}

export function createSSE (session, vueObj, sseListener) {
  setTimeout(function () {
    createSSeClient(session, vueObj)
  }, 800)
}

function createSSeClient (session, vueObj, retryCount = 0) {
  if (!vueObj.$root.sseClient || vueObj.$root.sseClient.url.indexOf('session=' + session) == -1) {
    vueObj.$root.sseClient = vueObj.$sse.create({
      url: global.getSSEURL() + '/api/SSE/Connect?session=' + session,
      format: 'json',
      polyfill: true,
    })
    vueObj.$root.sseClient.on('error', (e) => {
      console.error('lost connection or failed to parse!', e)
    })
    vueObj.$root.sseClient.on('IWLiveEvent', function (event) {
      resolvePush(event, vueObj)
    })
    vueObj.$root.sseClient.connect().then(sse => {
      vueObj.$root.sseClient.connected = true
      console.log('We\'re connected!')
    }).catch(err => {
      // When this error is caught, it means the initial connection to the
      // events server failed.  No automatic attempts to reconnect will be made.
      console.error('Failed to connect to server', err)
      let tmpSesson = localGet(global.key.session, '')
      if (tmpSesson !== session) {
        retryCount = 0
        session = tmpSesson
      }
      if (retryCount < 5) {
        createSSeClient(session, vueObj, ++retryCount)
      }
    })
  }
}

export function doLoginAsVisitor (successCallback = null, failCallBack = null, vueObj, showLoading = true, hideLoading = true) {
  return postB('api/Account/TryPlay',
    {
      'clientVersion': global.clientVersion,
      'deviceUUID': global.deviceUUID.toUpperCase(),
      'deviceName': 'FromWebApp',
      'channelId': global.channelId,
      'mobileInfo': '',
      'countryCode': 'US',
      'languageCode': '',
      'sign': gs()

    }, function (res) {
      if (res.roleType == 2) {
        failCallBack && failCallBack(ResultCode.RoleNotSupport, '', vueObj)
        return
      }
      //清空之前信息
      if (vueObj.$root.$sseClient) {
        vueObj.$root.$sseClient.disconnect()
        vueObj.$root.$sseClient = null
      }
      vueObj.$globalAppCfg.sseSource = null
      createSSE(res.session,vueObj)
      vueObj.$globalAppCfg.setUser({})
      vueObj.$globalAppCfg.setSession('')
      vueObj.$globalAppCfg.setGlobalParams({})
      if (vueObj.$root.rtm && vueObj.$root.rtm._logined) {
        vueObj.$root.rtm.logout().then(() => {
          console.log('logout')
          vueObj.$root.rtm._logined = false
          vueObj.$root.$globalAppCfg.agoChatClient = null
        }).catch((err) => {
          console.log('Logout failed, please open console see more details')
          console.log(err)
        })
      }
      IMManager.exit(vueObj)
      localClear()

      global.setUser(res.user)
      global.setGlobalParams(res.globalParam)
      global.setVideoChatRoomConfig(res.globalParam.videoChatRoomConfig)
      global.setSession(res.session)
      localSave(global.key.session, res.session)
      global.saveUser(res.user)
      if (!isnull(res.globalParam)) {
        global.saveServerCFG(res.globalParam)
        localSave(global.key.video_chat_config, JSON.stringify(res.globalParam.videoChatRoomConfig))
      }
      localSave(global.LOGIN_STATUS, true)
      global.setPList(res.globalParam.payConfigs)
      global.clearLinkParams()
      accountapi.doAttribute(null, null, vueObj)
      successCallback && successCallback(res, vueObj)
    }, function (code, msg) {
      failCallBack && failCallBack(code, msg, vueObj)
    }, '/webApp', vueObj, showLoading, hideLoading)
}

export function doLoginAsVisitorWithTK (token,successCallback = null, failCallBack = null, vueObj, showLoading = true, hideLoading = true) {
  return postB('api/Account/TryPlay',
    {
      'clientVersion': global.clientVersion,
      'deviceUUID': global.deviceUUID.toUpperCase(),
      'deviceName': 'FromWebApp',
      'channelId': global.channelId,
      'mobileInfo': '',
      'countryCode': 'US',
      'languageCode': '',
      'sign': gs(),
      'token':token

    }, function (res) {
      if (res.roleType == 2) {
        failCallBack && failCallBack(ResultCode.RoleNotSupport, '', vueObj)
        return
      }
      //清空之前信息
      if (vueObj.$root.$sseClient) {
        vueObj.$root.$sseClient.disconnect()
        vueObj.$root.$sseClient = null
      }
      vueObj.$globalAppCfg.sseSource = null
      createSSE(res.session,vueObj)
      vueObj.$globalAppCfg.setUser({})
      vueObj.$globalAppCfg.setSession('')
      vueObj.$globalAppCfg.setGlobalParams({})
      if (vueObj.$root.rtm && vueObj.$root.rtm._logined) {
        vueObj.$root.rtm.logout().then(() => {
          console.log('logout')
          vueObj.$root.rtm._logined = false
          vueObj.$root.$globalAppCfg.agoChatClient = null
        }).catch((err) => {
          console.log('Logout failed, please open console see more details')
          console.log(err)
        })
      }
      IMManager.exit(vueObj)
      localClear()

      global.setUser(res.user)
      global.setGlobalParams(res.globalParam)
      global.setVideoChatRoomConfig(res.globalParam.videoChatRoomConfig)
      global.setSession(res.session)
      localSave(global.key.session, res.session)
      global.saveUser(res.user)
      if (!isnull(res.globalParam)) {
        global.saveServerCFG(res.globalParam)
        localSave(global.key.video_chat_config, JSON.stringify(res.globalParam.videoChatRoomConfig))
      }
      localSave(global.LOGIN_STATUS, true)
      global.setPList(res.globalParam.payConfigs)
      global.clearLinkParams()
      accountapi.doAttribute(null, null, vueObj)
      successCallback && successCallback(res, vueObj)
    }, function (code, msg) {
      failCallBack && failCallBack(code, msg, vueObj)
    }, '/webApp', vueObj, showLoading, hideLoading)
}

export function doLogin (email, pwd, successCallback = null, failCallBack = null, vueObj, showLoading = true, hideLoading = true) {
  let password = md5(pwd);
  return postB('api/Account/Login',
    {
      'accountName': email,
      'password': password,
      'clientVersion': global.clientVersion,
      'deviceUUID': global.deviceUUID.toUpperCase(),
      'deviceName': 'FromWebApp',
      'channelId': global.channelId,
      'mobileInfo': '',
      'sign': gsWithAcc(email,password)

    }, function (res) {
      if (res.roleType == 2) {
        failCallBack && failCallBack(ResultCode.RoleNotSupport, '', vueObj)
        return
      }
      //清空之前信息
      if (vueObj.$root.$sseClient) {
        vueObj.$root.$sseClient.disconnect()
        vueObj.$root.$sseClient = null
      }
      vueObj.$globalAppCfg.sseSource = null
      vueObj.$globalAppCfg.setUser({})
      vueObj.$globalAppCfg.setSession('')
      vueObj.$globalAppCfg.setGlobalParams({})
      if (vueObj.$root.rtm && vueObj.$root.rtm._logined) {
        vueObj.$root.rtm.logout().then(() => {
          console.log('logout')
          vueObj.$root.rtm._logined = false
          vueObj.$root.$globalAppCfg.agoChatClient = null
        }).catch((err) => {
          console.log('Logout failed, please open console see more details')
          console.log(err)
        })
      }
      IMManager.exit(vueObj)
      localClear()

      //保存本次登录信息
      global.setUser(res.user)
      global.setGlobalParams(res.globalParam)
      global.setVideoChatRoomConfig(res.globalParam.videoChatRoomConfig)
      global.setSession(res.session)
      localSave(global.key.ac, aes.encrypt(email))
      localSave(global.key.pd, password)
      localSave(global.key.session, res.session)
     global.saveUser(res.user)
      if (!isnull(res.globalParam)) {
        global.saveServerCFG(res.globalParam)
        localSave(global.key.video_chat_config, JSON.stringify(res.globalParam.videoChatRoomConfig))
      }
      localSave(global.LOGIN_STATUS, true)
      global.setPList(res.globalParam.payConfigs)
      global.clearLinkParams()
      accountapi.doAttribute(null, null, vueObj)
      successCallback && successCallback(res, vueObj)
    }, function (code, msg) {
      failCallBack && failCallBack(code, msg, vueObj)
    }, '/webApp', vueObj, showLoading, hideLoading)
}

export function reloginInBg (successCallback = null, failCallBack = null, vueObj, showLoading = false, hideLoading = false) {
  if (isnull(global.key.ac) || isnull(global.pd)) {
    failCallBack && failCallBack(-10, null, vueObj)
    return
  }
  return postB('api/Account/Login',
    {
      'accountName': aes.decrypt(localGet(global.key.ac)),
      'password': localGet(global.key.pd),
      'clientVersion': global.clientVersion,
      'deviceUUID': global.deviceUUID.toUpperCase(),
      'deviceName': 'FromWebApp',
      'channelId': global.channelId,
      'mobileInfo': '',
      'sign': ''

    }, function (res) {

      //清空之前信息
      if (vueObj.$root.$sseClient) {
        vueObj.$root.$sseClient.disconnect()
        vueObj.$root.$sseClient = null
      }
      vueObj.$globalAppCfg.sseSource = null
      vueObj.$globalAppCfg.setUser({})
      vueObj.$globalAppCfg.setSession('')
      vueObj.$globalAppCfg.setGlobalParams({})
      if (vueObj.$root.rtm && vueObj.$root.rtm._logined) {
        vueObj.$root.rtm.logout().then(() => {
          console.log('logout')
          vueObj.$root.rtm._logined = false
          vueObj.$root.$globalAppCfg.agoChatClient = null
        }).catch((err) => {
          console.log('Logout failed, please open console see more details')
          console.log(err)
        })
      }
      IMManager.exit(vueObj)
      localClear()

      global.setUser(res.user)
      global.setGlobalParams(res.globalParam)
      global.setVideoChatRoomConfig(res.globalParam.videoChatRoomConfig)
      global.setSession(res.session)
      if (localGet(global.key.session) != res.session) {
        vueObj.$root.$sseClient = null
      }
      localSave(global.key.session, res.session)
      global.saveUser(res.user)
      if (!isnull(res.globalParam)) {
        global.saveServerCFG(res.globalParam)
        localSave(global.key.video_chat_config, JSON.stringify(res.globalParam.videoChatRoomConfig))
      }
      global.setPList(res.globalParam.payConfigs)
      localSave(global.LOGIN_STATUS, true)
      createSSE(res.session, vueObj)
      vueObj.$root.rtmManager.login()
      successCallback && successCallback(res, vueObj)
    }, function (code, msg) {
      failCallBack && failCallBack(code, msg, vueObj)
    }, '/webApp', vueObj, showLoading, hideLoading)
}

export function doLogout (successCallback = null, failCallBack = null, vueObj, showLoading = true, hideLoading = true) {
  return postQ('api/Account/Logout', ['session=' + localGet(global.key.session)], function (data) {
    loginOut(vueObj)
    successCallback && successCallback(data, vueObj)
  }, function (code, msg) {
    failCallBack && failCallBack(code, msg, vueObj)
  }, '/webApp', vueObj, showLoading, hideLoading)
}

export function checkEmail (email, successCallback = null, failCallBack = null, vueObj, showLoading = true, hideLoading = true) {
  return postQ('api/Account/CheckEmail', ['email=' + email], function (data) {
    successCallback && successCallback(data, vueObj)
  }, function (code, msg) {
    failCallBack && failCallBack(code, msg, vueObj)
  }, '/webApp', vueObj, showLoading, hideLoading)
}

export function sendEmailCode(email, successCallback = null, failCallBack = null, vueObj, showLoading = true, hideLoading = true) {
  return postQ('api/Account/SendVerificationCode', ['email=' + email,'session='+localGet(global.key.session)], function (data) {
    successCallback && successCallback(data, vueObj)
  }, function (code, msg) {
    failCallBack && failCallBack(code, msg, vueObj)
  }, '/webApp', vueObj, showLoading, hideLoading)
}

export function doReg (email, pwd, nickname = '', age = 0, gender = '', successCallback = null, failCallBack = null, vueObj, showLoading = true, hideLoading = true) {
  return postB('api/Account/Register',
    {
      'accountName': email,
      'password': md5(pwd),
      nickName: nickname,
      gender: gender,
      age: age,
      avatar: '',
      countryCode: 'US',
      languageCode: '',
      'clientVersion': '1.0.0',
      'deviceUUID': global.deviceUUID.toUpperCase(),
      'deviceName': 'FromWebApp',
      'channelId': global.channelId,
      'mobileInfo': '',
      'sign': ''

    }, successCallback, function (code, msg) {
      failCallBack && failCallBack(code, msg, vueObj)
    }, '/webApp', vueObj, showLoading, hideLoading)
}

export function doBind (code, pwd,  successCallback = null, failCallBack = null, vueObj, showLoading = true, hideLoading = true) {
  return postQ('api/Account/BindEmail',
    ['session=' + global.getSession(),'code='+code,'password='+md5(pwd)], function (res) {
      successCallback && successCallback(res, vueObj)
    }, function (code, msg) {
      failCallBack && failCallBack(code, msg, vueObj)
    }, '/webApp', vueObj, showLoading, hideLoading)
}

export function doPay (suffix, amount, productId, successCallback = null, failCallBack = null, vueObj, showLoading = true, hideLoading = true) {
  var data = new FormData()
  data.append('amount', amount)
  data.append('biz_content', JSON.stringify({
    'AccountId': global.getUserId(),
    'ProductId': productId,
    'ChannelId': global.channelId,
    'DeviceNo': global.deviceUUID.toUpperCase() + '-' + vueObj.$globalAppCfg.getUserId(),
    'Platform': 1,
  }))
  return postB(suffix, data, successCallback, function (code, msg) {
    failCallBack && failCallBack(code, msg, vueObj)
  }, '/pay', vueObj, showLoading, hideLoading)
}

export function follow (hostAccId, successCallback = null, failCallBack = null, vueObj, showLoading = true, hideLoading = true) {
  return postQ('/api/Account/Follow', ['session=' + localGet(global.key.session), 'targetAccountId=' + hostAccId], function (data) {
    successCallback && successCallback(data, vueObj)
  }, function (code, msg) {
    failCallBack && failCallBack(code, msg, vueObj)
  }, '/webApp', vueObj, showLoading, hideLoading)
}

export function cancelfollow (hostAccId, successCallback = null, failCallBack = null, vueObj, showLoading = true, hideLoading = true) {
  return postQ('/api/Account/CancelFollow', ['session=' + localGet(global.key.session), 'targetAccountId=' + hostAccId], function (data) {
    successCallback && successCallback(data, vueObj)
  }, function (code, msg) {
    failCallBack && failCallBack(code, msg, vueObj)
  }, '/webApp', vueObj, showLoading, hideLoading)
}




// WEBPACK FOOTER //
// ./src/api/home-api.js